import { z } from 'zod';
import { IndicatorType } from '@shared/types';

export const ZigZagInputSchema = z.object({
  type: z.literal(IndicatorType.ZIG_ZAG),
  deviationThreshold: z.number(),
  depth: z.number()
});

export type ZigZagInput = z.infer<typeof ZigZagInputSchema>;
